import moment from '@/utils/moment-wrapper.ts';

export function groupConversationsByDate (conversations) {
    const now = moment();
    const today = now.clone().startOf('day');
    const yesterday = today.clone().subtract(1, 'days');
    const lastWeekStart = today.clone().subtract(7, 'days');
    const lastMonthStart = today.clone().subtract(30, 'days');

    const grouped = {
        TODAY: [],
        YESTERDAY: [],
        LAST_7_DAYS: [],
        LAST_30_DAYS: [],
        OLDER: [],
    };

    conversations.forEach((conversation) => {
        const convDate = moment(conversation.lastUpdatedAt);
        const convStartOfDay = convDate.clone().startOf('day');

        if (convStartOfDay.isSame(today, 'day')) {
            grouped.TODAY.push(conversation);
        } else if (convStartOfDay.isSame(yesterday, 'day')) {
            grouped.YESTERDAY.push(conversation);
        } else if (convDate.isAfter(lastWeekStart)) {
            grouped.LAST_7_DAYS.push(conversation);
        } else if (convDate.isAfter(lastMonthStart)) {
            grouped.LAST_30_DAYS.push(conversation);
        } else {
            grouped.OLDER.push(conversation);
        }
    });

    return grouped;
}

export function formatConversationsForDropdown (conversations) {
    const grouped = groupConversationsByDate(conversations);
    const options = [];

    const labels = {
        TODAY: 'Today',
        YESTERDAY: 'Yesterday',
        LAST_7_DAYS: 'Last 7 Days',
        LAST_30_DAYS: 'Last 30 Days',
        OLDER: 'Older',
    };

    Object.keys(grouped).forEach((key) => {
        if (grouped[key].length > 0) {
            options.push({
                label: labels[key],
                options: grouped[key].filter((conv) => conv.name).map((conv) => ({
                    id: conv.id,
                    label: conv.name,
                    group: labels[key],
                })),
            });
        }
    });

    return options;
}